export default function Why() {
    return (
        <section
            id="why"
            data-testid="why-section"
            className="py-24 md:py-32 lg:py-40 rule-top"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-4 lg:col-span-3">
                        <span className="number-mark text-ink2">§ 02</span>
                        <h2
                            data-testid="why-heading"
                            className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.02] text-ink"
                        >
                            Helping systems respond to community priorities.
                        </h2>
                    </div>

                    <div className="col-span-12 md:col-span-8 lg:col-span-9 lg:pl-12">
                        <div className="prose max-w-none text-ink2 text-lg md:text-[19px] leading-[1.7] space-y-6">
                            <p>
                                <span className="float-left font-serif text-[5.5rem] leading-[0.85] mr-3 mt-1 text-ochre">
                                    A
                                </span>
                                ustralia cannot meet its climate, biodiversity
                                and restoration goals without Indigenous
                                authority. First Nations peoples hold continuing
                                rights, responsibilities and knowledge across
                                land, sea, water — and across the systems of
                                seed, restoration and Caring for Country that
                                hold them together.
                            </p>
                            <p>
                                Communities already know what is needed. The
                                gap is not knowledge; it is the way governments,
                                markets, agencies and partners are configured
                                to listen, fund and act.
                            </p>
                            <p>
                                <span className="text-ink">
                                    Our work is to help systems respond to those
                                    priorities.
                                </span>{" "}
                                To translate community direction into
                                governance, partnerships, investment pathways
                                and institutional weight — so the cultural
                                authority and practical work that already exists
                                is properly heard, supported and resourced.
                            </p>
                            <p>
                                Done well, this is not advocacy on behalf of
                                communities. It is infrastructure that allows
                                communities to lead.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
